var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.833,4H7.167C5.7,4 4.5,5.2 4.5,6.667V25.333C4.5,26.8 5.7,28 7.167,28H25.833C27.3,28 28.5,26.8 28.5,25.333V6.667C28.5,5.2 27.3,4 25.833,4ZM17.833,9.467L19.3,8L21.167,9.867L23.033,8L24.5,9.467L22.633,11.333L24.5,13.2L23.033,14.667L21.167,12.8L19.3,14.667L17.833,13.2L19.7,11.333L17.833,9.467ZM8.767,10.267H15.433V12.267H8.767V10.267ZM15.833,21.333H13.167V24H11.167V21.333H8.5V19.333H11.167V16.667H13.167V19.333H15.833V21.333ZM24.5,22.933H17.833V20.933H24.5V22.933ZM24.5,19.733H17.833V17.733H24.5V19.733Z",
    fill: "#6ECA8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.273a61cbe5e6954b8696eac28ba46b2f.svg";
export { ForwardRef as ReactComponent };